export default __webpack_public_path__ + "static/media/move-material-7.e1462363.webp";